import { GraveStoneIcon } from './GraveStoneIcon';

/**
 * author: Austin Andrews
 * id 4986CAC4-4886-4868-8D81-28F00376536A
 * name grave-stone
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grave-stone.svg
 * tags
 * - Holiday 
 */
export const TombstoneIcon = GraveStoneIcon;
export default TombstoneIcon